import { render, staticRenderFns } from "./peixunmgr.vue?vue&type=template&id=32a6b5ec&scoped=true"
import script from "./peixunmgr.vue?vue&type=script&lang=js"
export * from "./peixunmgr.vue?vue&type=script&lang=js"
import style0 from "./peixunmgr.vue?vue&type=style&index=0&id=32a6b5ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a6b5ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a6b5ec')) {
      api.createRecord('32a6b5ec', component.options)
    } else {
      api.reload('32a6b5ec', component.options)
    }
    module.hot.accept("./peixunmgr.vue?vue&type=template&id=32a6b5ec&scoped=true", function () {
      api.rerender('32a6b5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/train/peixunmgr.vue"
export default component.exports